<template>
  <div
    :id="id"
    class="v-input v-input--is-label-active v-input--is-dirty
      theme--light v-text-field v-text-field--prefix
      v-text-field--is-booted v-text-field--enclosed v-text-field--outlined"
    :label="label"
    data-v-647b5a48=""
  >
    <div class="v-input__control">
      <div class="v-input__slot">
        <fieldset aria-hidden="true">
          <legend style="width: 33.75px;">
            <span class="notranslate">&ZeroWidthSpace;</span>
          </legend>
        </fieldset><div class="v-text-field__slot">
          <label
            :for="id"
            class="v-label v-label--active theme--light"
            style="left: 0px; right: auto; position: absolute;"
          >{{ label }}</label>
          <percent-input
            :id="id"
            v-model="getValue"
            suffix
            type="text"
            v-bind="$attrs"
          />
        </div>
      </div><div class="v-text-field__details">
        <div class="v-messages theme--light">
          <div class="v-messages__wrapper" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InputPercentage',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    id: {
      type: String,
      default() {
        return `input:${this.$attrs.label}`;
      },
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', String(value).replace(',', '.'));
      },
    },
  },
};
</script>
